// Shared "Actions" category accent (Unreal convention: node color encodes
// category, never re-themed — same reasoning as cameraTheme.js's CAMERA_ACCENT
// and eventsTheme.js's EVENTS_ACCENT). Lives inside src/components/nodes/
// deliberately: that directory is the node-body/pin/wire functional-color
// exemption in tests/unit/paletteEnforcement.test.mjs, so this constant gives
// EventGraph.jsx's action + debug palette entries ONE source instead of
// fifteen copies of the same literal (the copy count is what made adding a
// sixteenth action node fail the hex ratchet — ENG-1031).
//
// The action NODE BODIES in SentenceControlNodes.jsx keep their own local
// ACCENT constant; unifying those is a bigger sweep than this node needed.
export const ACTIONS_ACCENT = '#40d090'
